import { observer } from 'mobx-react-lite';
import { HospitalQueueRowData } from '../../../socket/stream-types';
import useDimensions from 'react-cool-dimensions';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { HospitalStatusTag } from '../../../common/components/hospital-status-tag';

export const HospitalQueueStatusCell = observer(function HospitalQueueStatusCell({
    data,
}: {
    data: HospitalQueueRowData;
}): React.ReactElement {
    const { observe } = useDimensions();

    return (
        <BaseQueueCell display="flex" margin="0 -3px" ref={observe}>
            <HospitalStatusTag
                hospitalStatus={data.hospitalStatus}
                hospitalStatusGlobalAttributeId={data.hospitalStatusGlobalAttributeId}
            />
        </BaseQueueCell>
    );
});
